//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import { resourcesStyles } from '../../styles/resourcesStyles';
import Arrow from '../../icons/ArrowIcon';

export type CardData = {
  title: string;
  imageURL: string;
  buttonLinks: string[];
};

const buttonNames = ['Getting started guide', 'User Documentation'];

type ResourcesCardProps = {
  cardsData: CardData[];
};

function ResourcesCard({ cardsData }: ResourcesCardProps) {
  return (
    <div
      id="resources-card-main"
      data-testid="resources-card-main"
      style={{
        ...resourcesStyles.cardMain,
        flexDirection: 'row',
        flexWrap: 'wrap',
      }}
    >
      {cardsData.map((card, index) => (
        <div
          id={`resource-card-${index}`}
          key={index}
          data-testid={`resource-card-${index}`}
          style={{
            ...resourcesStyles.cardStructure,
            flexDirection: 'column',
          }}
        >
          <img
            id={`resource-card-image-${index}`}
            src={card.imageURL}
            alt={card.title}
            style={resourcesStyles.image}
          />
          <p
            id={`resource-card-title-${index}`}
            className="card-title"
            style={resourcesStyles.cardtitle}
          >
            {card.title}
          </p>
          <div
            id={`resource-card-buttons-${index}`}
            data-testid={`resources-card-buttons-${index}`}
            style={{
              ...resourcesStyles.cardButtonStructure,
              flexDirection: 'column',
            }}
          >
            {card.buttonLinks.slice(0, 2).map((link, buttonIndex) => (
              <a
                id={`resource-card-button-${index}-${buttonIndex}`}
                key={buttonIndex}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                style={resourcesStyles.cardButtons}
              >
                {buttonNames[buttonIndex]}
                <Arrow />
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ResourcesCard;
